const cookieConsent = () => {
	const closed = localStorage.getItem('closed_cookie_banner');
	const banner = document.querySelector('.cookie-consent')

	if (!closed && banner) {
		banner.style.display = '';
	}

	const cookieButton = document.querySelector('.cookie-consent__close');
	if (cookieButton && banner) {
		cookieButton.addEventListener('click', () => {
			localStorage.setItem('closed_cookie_banner', true);
			banner.style.display = 'none';
		});
	}

};

export default cookieConsent;


// WEBPACK FOOTER //
// ./scripts/modules/cookieConsent.js